import { render, staticRenderFns } from "./editaturtle.vue?vue&type=template&id=4a7cc47b&scoped=true"
import script from "./editaturtle.vue?vue&type=script&lang=js"
export * from "./editaturtle.vue?vue&type=script&lang=js"
import style0 from "./editaturtle.vue?vue&type=style&index=0&id=4a7cc47b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7cc47b",
  null
  
)

export default component.exports